import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FooterLinksComponent } from './footer-links/footer-links.component';
import { LanguageSwitcherComponent } from './language-switcher/language-switcher.component';

@NgModule({
  declarations: [
    FooterLinksComponent
  ],
  imports: [
    CommonModule,
    LanguageSwitcherComponent
  ],
  exports: [
    FooterLinksComponent,
    LanguageSwitcherComponent
  ]
})
export class SharedModule { } 